import React, { useEffect, useState } from "react";
import Button from "~/components/button";
import styled from "@emotion/styled";
import { AddFolderFormDialog } from "./AddFolderFormDialog";
import { Project, SharedDrive } from "~/gql/types2";
import { useSharedDrivesAsync } from "~/refdata2/sharedDrives";

const RedTextButton = styled(Button)`
  &.mdc-button {
    color: var(--mdc-theme-secondary);
    height: unset;
  }
`;

type AddFolderProps = {
  project: Project;
};

export const AddFolder: React.FC<AddFolderProps> = ({ project }) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [drives, setDrives] = useState<SharedDrive[] | null>(null);
  const loading = drives === null;

  const getSharedDrives = useSharedDrivesAsync();

  useEffect(() => {
    const handle = async () => {
      const res = await getSharedDrives();

      setDrives(res ?? []);
    };

    void handle();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <RedTextButton onClick={() => setOpenDialog(true)} dense>
        Add
      </RedTextButton>
      <AddFolderFormDialog
        open={openDialog}
        setOpen={setOpenDialog}
        project={project}
        folderDrives={drives ?? []}
        drivesLoading={loading}
      />
    </>
  );
};
